<template>
  <div id="mb-custom-roulette">
    <div
      class="mb-custom-roulette-scalable"
      :style="{
        transform: 'translate(-50%, -50%) scale(' + scale + ')',
      }"
    >
      <div class="local-roulette-select" v-if="localDbData && !showRoulette">
        <div
          :value="itm"
          class="local-roulette-select-item"
          @click="
            select = itm;
            getLocalRoulette(itm.id);
          "
          v-for="(itm, index) in localDbData.rows"
          :key="'roulette-local-' + index"
        >
          {{ itm.id }}
        </div>
      </div>
      <div class="element-adder" v-if="!showRoulette">
        <p>Stwórz ruletke!</p>
        <div class="element-adder-item">
          <div class="left">
            <span>typ:</span>
          </div>
          <div class="right">
            <span
              :style="[cutomRoulette.rouletteType == 'rotate' ? { color: 'black' } : { color: 'gray' }]"
              @click="cutomRoulette.rouletteType = 'rotate'"
            >
              Obrotowa
            </span>
            <span
              :style="[cutomRoulette.rouletteType == '' ? { color: 'black' } : { color: 'gray' }]"
              @click="cutomRoulette.rouletteType = ''"
            >
              Światełkowa
            </span>
          </div>
        </div>
        <div class="element-adder-item">
          <div class="left">
            <span>ilośc elementów:</span>
          </div>
          <div class="right">
            <span
              v-for="(itm, index) in 10"
              :key="'custome-roulette-items-' + index"
              :style="[elementNumber == itm + 1 ? { color: 'black' } : { color: 'gray' }]"
              @click="
                elementNumber = itm + 1;
                crateTable(itm + 1);
              "
              v-html="itm + 1 + ' '"
            ></span>
          </div>
        </div>
        <div
          class="element-adder-item"
          v-for="(rouletItem, rouletIndex) in cutomRoulette.items"
          :key="'custom-roulette-text-' + rouletIndex"
        >
          <div class="left">
            <span>text elementu ruletki {{ rouletIndex + 1 }}:</span>
          </div>
          <div class="right">
            <input
              type="text"
              v-model="cutomRoulette.items[rouletIndex].text.line0"
              class="form-input"
              :maxlength="(100 - elementNumber * 3) / elementNumber"
            />
          </div>
        </div>
        <div class="element-adder-item icon-container">
          <!-- <img draggable="false" v-if="!showRoulette" @click="addElement()" :src="addIcon" style="padding: 10px" /> -->
          <img draggable="false" @click="rouletteShow()" :src="addIcon" style="padding: 10px" />
          <button @click="clearLocalRoulette()">CLEAR DB</button>
          <button @click="addCustomRouletteToLocalDb()">DODAJ DO DB</button>
        </div>
      </div>
      <div class="icon-container-small" @mouseenter="exitIconHover = true" @mouseleave="exitIconHover = false">
        <img draggable="false" class="exit-icon controll-icon-small" @click="closeModal()" :src="exitIcon" />
        <transition name="icon-fade">
          <img
            draggable="false"
            v-if="exitIconHover"
            class="controll-icon-small"
            @click="closeModal()"
            :src="exitIconOn"
          />
        </transition>
      </div>
      <transition name="modal-fade">
        <mb-roulette v-if="showRoulette" :start-game-config="cutomRoulette"></mb-roulette>
      </transition>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import MbRoulette from '../MbRoulette';
import PouchDB from 'pouchdb-browser';
export default {
  name: 'mb-custom-roulette',
  components: { MbRoulette },
  data: function () {
    return {
      exitIconHover: false,
      select: null,
      elementNumber: 0,
      rouletteText: '',
      scaleW: 1,
      showRoulette: false,
      scaleH: 1,
      scale: 1,
      localDB: null,
      localDbData: null,
      cutomRoulette: {
        rouletteType: '',
        items: [],
      },
      colors: [
        '#3cb44b',
        '#ffe119',
        '#4363d8',
        '#911eb4',
        '#42d4f4',
        '#f032e6',
        '#bfef45',
        '#fabed4',
        '#dcbeff',
        '#9A6324',
        '#aaffc3',
      ],
    };
  },
  mounted() {
    this.scaleW = this.setWidthScale();
    this.scaleH = this.setHeightScale();
    this.resizeWindow();
    this.initDb();
  },
  methods: {
    initDb() {
      this.localDB = new PouchDB('customeRoulette', { auto_compaction: true });
      // console.log(localDB);
      this.getAllLocalRoulette();
    },
    getAllLocalRoulette() {
      this.localDB
        .allDocs()
        .then((response) => {
          this.localDbData = response;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    crateTable(x) {
      this.cutomRoulette.items = [];
      for (let i = 0; i < x; i++) {
        this.cutomRoulette.items.push({
          text: { line0: '' },
          color: this.colors[this.cutomRoulette.items.length],
        });
      }
    },
    addElement() {
      this.cutomRoulette.items.push({
        text: { line0: this.rouletteText },
        color: this.colors[this.cutomRoulette.items.length],
      });
      this.rouletteText = '';
    },
    getLocalRoulette(id) {
      this.localDB
        .get(id)
        .then((response) => {
          console.log(response);
          this.cutomRoulette = response.conf;
          this.elementNumber = response.conf.items.length;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clearLocalRoulette() {
      this.localDB
        .destroy()
        .then((response) => {
          console.log(response);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addCustomRouletteToLocalDb() {
      this.localDB
        .put(
          {
            _id: 'my_roulette_' + this.localDbData.rows.length,
            conf: this.cutomRoulette,
          },
          { force: true }
        )
        .then((response) => {
          console.log(response);
          this.getAllLocalRoulette();
        })
        .catch((err) => {
          if (err.name === 'conflict') {
            console.log('conflick');
          }
          console.log(err);
        });
    },
    rouletteShow() {
      this.showRoulette = !this.showRoulette;
    },
    closeModal() {
      this.$emit('closeCustomRoulette');
    },
    setWidthScale() {
      let itm = document.getElementById('mb-custom-roulette').getBoundingClientRect();
      console.log(itm);
      return itm.width / 1920;
    },
    setHeightScale() {
      let itm = document.getElementById('mb-custom-roulette').getBoundingClientRect();
      console.log(itm);
      return itm.height / 1080;
    },
    resizeWindow(e) {
      let itm = document.getElementById('mb-custom-roulette').getBoundingClientRect();
      this.scale = Math.min(itm.width / 1920, itm.height / 1080);
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    exitIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-64px.png`);
      } catch {
        console.log(
          '%cExitIcon MbCustomRoulette- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    exitIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-on-64px.png`);
      } catch {
        console.log(
          '%cEXITIconOn MbCustomRoulette- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    addIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/add-64px.png`);
      } catch {
        console.log(
          '%cAddIcon MbCustomRoulette- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
  },
};
</script>

<style lang="sass" scoped>
$break-large: 1400px
#mb-custom-roulette
  width: 100%
  position: absolute
  top: 0
  height: 100%
  z-index: 8
  background: #f2f2f2
  .mb-custom-roulette-scalable
    width: 1920px
    height: 1080px
    top: 0
    left: 0
    background: #ffd100
    text-align: center
    position: relative
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    transform-origin: center center
    display: flex
    align-items: center
    flex-direction: column
    justify-content: center
    .local-roulette-select
      position: absolute
      top: 0
      left: 0
      background: #f2f2f2
      filter: drop-shadow(10px 10px 10px rgba(0,0,0, .4))
      .local-roulette-select-item
        margin: 5px
        padding: 10px 20px
        transition: .5s
        background: #f2f2f2
        cursor: pointer
        font-size: 24px
        &:hover
          background: gray
    .element-adder
      padding: 30px
      max-height: 1050px
      width: 1000px
      background: #f2f2f2
      filter: drop-shadow(10px 10px 10px rgba(0,0,0, .4))
      border-radius: 20px
      display: flex
      align-items: center
      flex-direction: column
      justify-content: center
      p
        margin: 10px
        padding: 0

      .element-adder-item
        width: 100%
        text-align: left
        padding: 10px 0px
        .left
          width: 30%
          display: inline-block
        .right
          width: 65%
          display: inline-block
        span
          font-size: 24px
          transition: .3s
        .form-group
          position: relative
          padding: 15px 0 0
          margin-top: 10px
          width: 50%
        .form-input
          width: 100%
          border: 0
          border-bottom: 2px solid gray
          outline: 0
          font-size: 24px
          color: black
          // padding: 7px 0
          background: transparent
          transition: border-color 0.2s
        .form-input:focus
          padding-bottom: 6px
          border-width: 3px
          border-image: linear-gradient(to right, #ffd100, #ffd100)
          border-image-slice: 1
      .icon-container
        display: flex
        align-items: center
        flex-direction: row
        justify-content: space-between
  .icon-container-small
    display: inline-block
    position: absolute
    top: 40px
    right: 30px
    width: 48px
    height: 48px

    .controll-icon, .controll-icon-small
      position: absolute
      top: 0
      left: 0
      width: 48px
      height: 48px
      transition: .5s
      // transform: scale(.9)
      cursor: pointer
    .controll-icon-small
      width: 32px
      height: 32px
      margin-top: -15px
      margin-left: 20px

@keyframes iconShow
  0%
    opacity: 0
    transform: rotate(-25deg) scale(.9)
  50%
    opacity: 1
    transform: rotate(-25deg) scale(.9)
  100%
    opacity: 1

.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .5s linear
.modal-fade-leave-to, .modal-fade-enter
  opacity: 0
.icon-fade-leave-active, .icon-fade-enter-active
  transition: all .5s linear
.icon-fade-leave-to, .icon-fade-enter
  opacity: 0
</style>
